@charset "UTF-8";

/* src/app/shared/components/side-bar-menu/side-bar-menu.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.side-bar-menu {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  background-color: #dfdbd7;
  font-size: 1rem;
  width: 0;
}
@media screen and (min-width: 48rem) {
  .side-bar-menu {
    width: 3.75em;
  }
}
.side-bar-menu + .ui-blocker {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 16, 16, 0.3);
  z-index: 3;
  transition: all 0.3s ease-in-out;
  touch-action: none;
}
.side-bar-menu.opened {
  width: 18.75em;
}
.side-bar-menu.opened .sidebar-menu-label {
  display: flex;
}
.side-bar-menu.opened + .ui-blocker {
  visibility: visible;
  opacity: 1;
}
@media screen and (min-width: 64rem) {
  .side-bar-menu.opened + .ui-blocker {
    visibility: hidden;
    opacity: 0;
  }
}
.side-bar-menu.opened ul.sidebar-nav li {
  margin-bottom: 1px;
}
.side-bar-menu.opened ul.sidebar-nav li a.has-submenu {
  cursor: pointer;
}
.side-bar-menu.opened ul.sidebar-nav li a.has-submenu::after {
  visibility: visible;
  opacity: 1;
}
.side-bar-menu.opened ul.sidebar-nav li a span:not(.badge) {
  visibility: visible;
  opacity: 1;
  transition: all 0.3s ease;
}
.side-bar-menu.opened .sidebar-footer {
  width: 100%;
  visibility: visible;
  opacity: 1;
}
@media screen and (min-width: 64rem) {
  .side-bar-menu.opened .sidebar-footer .links,
  .side-bar-menu.opened .sidebar-footer .copyright {
    display: flex;
  }
}
.side-bar-menu ul.sidebar-nav {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.side-bar-menu ul.sidebar-nav li a {
  white-space: nowrap;
  text-decoration: none;
  color: rgba(36, 36, 36, 0.87);
}
@media screen and (min-width: 64rem) {
  .side-bar-menu ul.sidebar-nav li a {
    transition: background-color 0.1s linear;
  }
}
.side-bar-menu ul.sidebar-nav li a:hover {
  background-color: #cac4bd;
}
.side-bar-menu ul.sidebar-nav li a.active-menu {
  background-color: #d5cfc9;
  font-weight: 700;
}
.side-bar-menu ul.sidebar-nav li a.has-submenu {
  position: relative;
}
.side-bar-menu ul.sidebar-nav li a.has-submenu::after {
  content: "\e313";
  font-family: "Material Icons";
  position: absolute;
  top: 0;
  right: 0.5em;
  display: inline-block;
  visibility: hidden;
  opacity: 0;
  transition: all 0.3s ease;
}
.side-bar-menu ul.sidebar-nav li a.has-submenu.opened {
  background-color: #d5cfc9;
}
.side-bar-menu ul.sidebar-nav li a.has-submenu.opened::after {
  transform: rotateX(-180deg);
}
.side-bar-menu ul.sidebar-nav li a.has-submenu.opened + .sidebar-submenu {
  background-color: #d5cfc9;
}
.side-bar-menu ul.sidebar-nav li a .menu-icon {
  margin: 0 1em 0 0.25em;
  width: 1.3125rem;
  height: auto;
}
.side-bar-menu ul.sidebar-nav li a span:not(.badge) {
  font-size: 1em;
  visibility: hidden;
  opacity: 0;
  width: 0;
}
.side-bar-menu ul.sidebar-nav li a .sidebar-menu-label {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.side-bar-menu ul.sidebar-nav li a .sidebar-menu-label .label-text {
  width: auto;
}
.side-bar-menu ul.sidebar-nav li > a {
  font-size: 0.9375em;
  line-height: 3.35;
  padding-left: 1em;
}
.side-bar-menu ul.sidebar-nav li > ul.sidebar-submenu {
  overflow: hidden;
  max-height: 0;
  visibility: hidden;
  opacity: 0;
  list-style-type: none;
  transition: all 0.3s ease-in-out;
}
.side-bar-menu ul.sidebar-nav li > ul.sidebar-submenu.active {
  height: auto;
  max-height: 500px;
  visibility: visible;
  opacity: 1;
}
.side-bar-menu ul.sidebar-nav li > ul.sidebar-submenu > li.sidebar-menu-wrapper > a {
  padding-left: 1em;
}
.side-bar-menu ul.sidebar-nav li > ul.sidebar-submenu > li.sidebar-menu-wrapper > a > .menu-icon {
  margin-left: 1em;
  zoom: 0.85;
}
.side-bar-menu ul.sidebar-nav li > ul.sidebar-submenu > li.sidebar-menu-wrapper > a + ul.sidebar-submenu {
  padding-left: 0;
}
.side-bar-menu ul.sidebar-nav li > ul.sidebar-submenu li.active a {
  background-color: #d5cfc9;
  font-weight: 700;
}
.side-bar-menu ul.sidebar-nav li > ul.sidebar-submenu li a {
  color: #595555;
  font-weight: 500;
  font-size: 0.8125em;
  line-height: 3.1;
  margin-left: -3em;
  padding-left: 3.3125rem;
}
.side-bar-menu ul.sidebar-nav li > ul.sidebar-submenu li a:hover {
  background-color: #cac4bd;
}
.side-bar-menu .sidebar-footer {
  width: 0;
  visibility: hidden;
  opacity: 0;
  margin-top: auto;
  padding-left: 1em;
  transition: all 0.3s ease-in-out;
}
@media screen and (min-width: 64rem) {
  .side-bar-menu .sidebar-footer .sidebar-footer-menu-trigger {
    display: none;
  }
}
.side-bar-menu .sidebar-footer .help-icon-wrapper {
  width: 2.1875rem;
  height: 2.1875rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 50%;
  margin-bottom: 0.5rem;
  margin-left: -0.25rem;
}
@media screen and (min-width: 64rem) {
  .side-bar-menu .sidebar-footer .help-icon-wrapper {
    display: none;
  }
}
.side-bar-menu .sidebar-footer .links {
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  min-width: 17.3em;
  padding-top: 2em;
}
.side-bar-menu .sidebar-footer .links .link {
  font-size: 0.75em;
  line-height: 1;
  letter-spacing: 0.2px;
  color: #595555;
  margin: 0.5em 0;
}
.side-bar-menu .sidebar-footer .links .link:nth-child(odd) {
  padding: 0em 1em;
}
.side-bar-menu .sidebar-footer .links .link:nth-child(odd):not(:last-child) {
  border-right: solid thin #595555;
}
.side-bar-menu .sidebar-footer .links .link:nth-child(even) {
  padding: 0em 1em;
}
.side-bar-menu .sidebar-footer .links .link:nth-child(even):not(:last-child) {
  border-right: solid thin #595555;
}
.side-bar-menu .sidebar-footer .copyright {
  font-size: 0.7em;
  padding: 1.5em 2em 2em 1.5em;
  margin-left: -0.5em;
  min-width: 100%;
  white-space: pre-wrap;
}
@media screen and (min-width: 48rem) and (max-width: 64rem) {
  .side-bar-menu .sidebar-footer .copyright {
    margin-bottom: 6em;
  }
}
@media screen and (min-width: 64rem) {
  .side-bar-menu .sidebar-footer .copyright {
    display: none;
  }
}
.side-bar-menu .menu-toggle .mat-icon {
  margin-left: -0.3em;
  color: rgba(36, 36, 36, 0.87);
}
.side-bar-menu .sidebar-trigger {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 5em;
}
.side-bar-menu .sidebar-trigger .hamburger {
  visibility: hidden;
  opacity: 0;
  transition: all 0.3s ease;
}
@media screen and (min-width: 48rem) {
  .side-bar-menu .sidebar-trigger .hamburger {
    visibility: visible;
    opacity: 1;
  }
}
.side-bar-menu .sidebar-trigger .hamburger.is-active {
  visibility: visible;
  opacity: 1;
}
.side-bar-menu .sidebar-menu-wrapper.divider {
  width: 100%;
  border-top: solid thin #d9d9d6;
  margin: 0.5em 0;
}
.side-bar-menu .sidebar-menu-wrapper a {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.side-bar-menu .sidebar-menu-wrapper a .mat-icon {
  margin: 0 0.7em 0 0.15em;
  font-size: 1.5em;
  line-height: 1.1;
}
.side-bar-menu .sidebar-menu-wrapper .sidebar-submenu li a .just-launched-text {
  margin-left: 12px;
  width: 105px;
  height: 26px;
  color: #fafcf7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #004791;
}
.new-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  justify-content: center;
  margin: 0 0.5em;
  padding: 0 0.5em;
  font-size: 0.75rem !important;
  line-height: 1.75;
  font-weight: 300;
  color: #fafcf7;
  background-color: #004791;
  width: auto !important;
  height: auto;
}
.link {
  cursor: pointer;
}
.link:hover {
  text-decoration: underline;
}
.worldship-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin: 0 0.5em;
  padding: 0 1.1em 0 0.5em;
  font-size: 0.75rem !important;
  line-height: 1.75;
  color: #fafcf7;
  background-color: #004791;
  width: auto !important;
  height: auto;
  position: relative;
  border-radius: 3px;
}
.worldship-badge::after {
  content: "\ae";
  font-size: 7px;
  position: absolute;
  right: 6px;
  top: 2px;
}
/*# sourceMappingURL=side-bar-menu.component.css.map */
